// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1907":"c0bbe996","4823":"c0bbe996","8676":"51ae0912"}[chunkId] + ".chunk.css";
};